




















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IField } from '@/fields/types/field';
import { EFieldType } from '@/fields/types/enums/field-type';
import SignatureFieldSettings from '@/fields/signature-field/components/SignatureFieldSettings.vue';
import LinkFieldSettings from '@/fields/link-field/components/LinkFieldSettings.vue';
import DropdownFieldSettings from '@/fields/dropdown-field/components/DropdownFieldSettings.vue';
import CheckboxFieldSettings from '@/fields/checkbox-field/components/CheckboxFieldSettings.vue';
import MergeFieldSettings from '@/fields/merge-field/components/MergeFieldSettings.vue';
import TextFieldSettings from '@/fields/text-field/components/TextFieldSettings.vue';
import InitialsFieldSettings from '@/fields/initials-field/components/InitialsFieldSettings.vue';
import { IRecipient } from '@/types/Recipient';
import { EnumDocumentType } from '@/enums/DocumentType';

@Component({
  components: {
    SignatureFieldSettings,
    LinkFieldSettings,
    DropdownFieldSettings,
    CheckboxFieldSettings,
    MergeFieldSettings,
    TextFieldSettings,
    InitialsFieldSettings,
  },
  data: () => ({
    EFieldType,
  }),
})
export default class FieldSettings extends Vue {
  @Prop() field!: IField;
  @Prop() recipients: IRecipient[];
  @Prop() documentType: EnumDocumentType;
  @Prop() height: string;

  handleUpdate(payload: Partial<IField>) {
    this.$emit('update', [{ ...this.field, ...payload }]);
  }

  get isTemplate(): boolean {
    return this.documentType === EnumDocumentType.Template;
  }
}
